module.exports = __webpack_public_path__ + "img/54.d5221f3e.jpg";